(($, Drupal) => {
    Drupal.behaviors.switcherLabels = {
        attach: function attach() {
            $(".switcher__labels").once("switcher-labels").each(function() {
                const switcher = $(this);
                switcher.data('owl.carousel').options.items = 2;
                switcher.data('owl.carousel').options.stagePadding = 30;
                switcher.trigger('refresh.owl.carousel');
            });
        }
    };

})(jQuery, Drupal);
  